// extracted by mini-css-extract-plugin
export default {"upload":"FileUpload_upload__UAyYb","modalImg":"FileUpload_modalImg__Vxdsx","modalBtn":"FileUpload_modalBtn__zDal1"};